import { Button, ModalProps } from "antd";
import React, { useState } from "react";
import { AppDispatch } from "../../../../store/app";
import { useDispatch } from "react-redux";
import { deleteSupportProvider } from "../../../../store/SupportProviderSlice";
import CommonModal from "../../../../components/Modals/CommonModal";

interface DeleteModalProps extends ModalProps {
    title?: string;
    close: any;
    open: boolean;
    deleteValues: any;
    name?: string | number;
    getList: any;
}

const DeleteSupportProvider: React.FC<DeleteModalProps> = ({
    deleteValues,
    getList,
    title,
    open,
    name,
    close
}) => {
    const dispatch: AppDispatch = useDispatch();
    const [saving, setSaving] = useState<boolean>(false);

    const deleteProduct = () => {
        setSaving(true);

        const payload = {
            id: deleteValues?.row_id,
        };

        dispatch(deleteSupportProvider(payload))
            .then(() => {
                close();
                getList();
            })
            .catch(() => {
                close();
            })
            .finally(() => setSaving(false));
    };
    return deleteValues ? (
        <CommonModal
            className="deleteModal"
            title={`Delete ${name}: ${title}`}
            open={open ? true : false}
            onCancel={close}
            footer={[
                <Button
                    key="2"
                    htmlType="button"
                    className="EditBtn"
                    onClick={close}
                >
                    Cancel
                </Button>,
                <Button
                    key="1"
                    htmlType="button"
                    type="primary"
                    className="cancelBtn"
                    loading={saving}
                    onClick={deleteProduct}
                >
                    Delete
                </Button>,
            ]}
        >
            <div className="deleteNote">
                Are you sure want to delete
                <br />
                <strong>
                    {name && <span>{name}:</span>} {title}
                </strong>
                ?
            </div>
        </CommonModal>
    ) : (
        <></>
    );
}
export default DeleteSupportProvider